import { render } from "./CreatePermission.vue?vue&type=template&id=03a3d948&scoped=true"
import script from "./CreatePermission.vue?vue&type=script&lang=js"
export * from "./CreatePermission.vue?vue&type=script&lang=js"

import "./CreatePermission.vue?vue&type=style&index=0&id=03a3d948&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a3d948"]])

export default __exports__